export const Platforms = Object.freeze({
    ONE_DRIVE: 'OneDrive',
    GOOGLE_DRIVE: 'GoogleDrive',
});
